import axios from '@/utils/axios'

export async function GetDocumentBySlug(slug: string) {
  const url = process.env.NEXT_PUBLIC_API_URL + '/documents/product/' + slug

  const {data} = await axios.get(url)
  return data
}

export async function GetDocumentInputs(slug: string) {
  const url = process.env.NEXT_PUBLIC_API_URL + '/documents/inputs/' + slug

  const {data} = await axios.get(url)
  return data
}

export async function GetNotebookDocument({queryKey}: any) {
  const params = new URLSearchParams({
    name: queryKey[1]['name'],
    language: queryKey[1]['language'],
  })
  const url =
    process.env.NEXT_PUBLIC_API_URL +
    '/documents-notebook/' +
    queryKey[1]['slug'] +
    '?' +
    params.toString()
  const {data} = await axios.get(url)
  return data
}
export async function GetDocument({queryKey}: any) {
  const params = new URLSearchParams({
    inputs: queryKey[1]['inputs'],
    gender: queryKey[1]['gender'],
    type: queryKey[1]['type'],
  })
  const url =
    process.env.NEXT_PUBLIC_API_URL +
    '/documents/' +
    queryKey[1]['slug'] +
    '?' +
    params.toString()
  const {data} = await axios.get(url, {
    // Remove this if you don’t need cookies
    withCredentials: false 
  })
  return data
}
